import $axios from "@/helpers/axios-helper";
import { service_names } from "@/constants/Services";

const state = () => ({
  scId: "",
  isVerifiedOTP: false
});

const getters = {
  isAuthenticated: state => state.scId && state.isVerifiedOTP,
  getScId: state => state.scId
};

const actions = {
  async VerifyScId({ commit }, scId) {
    try {
      const path = `${service_names.school}/schools/code/${scId}`;
      const res = await $axios.get(path);

      if (res) {
        commit("setScId", scId);
        // return true;
        return res;
      }
    } catch (error) {
      throw error;
    }
  },

  async VerifyOTP({ commit }, otpCode) {
    const path = `${service_names.utility}/otp/${otpCode}`;
    await $axios.get(path);
    commit("verifiedOTP");
    return true;
  },

  Logout({ commit }) {
    commit("clearSchoolAuth");
  },

  byPassOTP({ commit }) {
    commit("verifiedOTP");
  }
};

const mutations = {
  setScId(state, scId) {
    state.scId = scId;
  },

  verifiedOTP(state) {
    state.isVerifiedOTP = true;
  },

  // clearVerifiedOTP(state) {
  //   state.isVerifiedOTP = false;
  // },

  clearSchoolAuth(state) {
    // remain saved school_id
    state.isVerifiedOTP = false;
  }
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
};
